export class TypeformImage {
    constructor(
        public id: string,
        public src: string,
        public file_name: string,
        public width: number,
        public height: number,
        public media_type: string,
        public has_alpha: boolean,
        public avg_color: string,
    ) {}

    static fromData(data: any): TypeformImage {
        if (data === null || typeof data === 'string' || data instanceof TypeformImage) {
            return data
        }

        return new TypeformImage(
            data.id,
            data.src,
            data.file_name,
            data.width,
            data.height,
            data.media_type,
            data.has_alpha,
            data.avg_color,
        )
    }
}
